import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  codeForwarding: false,
};

const globalflag = createSlice({
  name: "globalflag",
  initialState,
  reducers: {
    setCodeForwarding: (state, action) => {
      state.codeForwarding = action.payload;
    },
  },
});

export const { setCodeForwarding } = globalflag.actions;

export default globalflag.reducer;
